// src/routes/paxTypesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import PaxTypes from '../pages/paxTypes/PaxTypes';
import CreatePaxTypes from '../pages/paxTypes/CreatePaxTypes';
import EditPaxTypes from '../pages/paxTypes/EditPaxTypes';
import ProtectedRoute from '../components/global/ProtectedRoute';

const paxTypesRoutes = (
    <>
        {/* Pax Types List */}
        <Route
            path="/pax-types"
            element={
                <ProtectedRoute requiredPermission="paxTypes_list">
                    <PaxTypes />
                </ProtectedRoute>
            }
        />

        {/* Pax Types Archive */}
        <Route
            path="/pax-types/archive"
            element={
                <ProtectedRoute requiredPermission="paxTypes_archive_list">
                    <PaxTypes />
                </ProtectedRoute>
            }
        />

        {/* Create Pax Type */}
        <Route
            path="/pax-types/create"
            element={
                <ProtectedRoute requiredPermission="paxTypes_create">
                    <CreatePaxTypes />
                </ProtectedRoute>
            }
        />

        {/* Edit Pax Type */}
        <Route
            path="/pax-types/:id/edit"
            element={
                <ProtectedRoute requiredPermission="paxTypes_edit">
                    <EditPaxTypes />
                </ProtectedRoute>
            }
        />
    </>
);

export default paxTypesRoutes;